import { Zone } from 'sonata-static-storage/lib/schemas/zone/zone.schema';

export function getLocationListTitle(location: Partial<Zone>): string {
  let name = location.name ?? 'New Location';
  if (location.prefix) {
    name = `${location.prefix} - ${name}`;
  }
  if (location.suffix) {
    name = `${name} - ${location.suffix}`;
  }

  return name;
}
